import { render, staticRenderFns } from "./CSlider.vue?vue&type=template&id=5df5a5b2&scoped=true&"
import script from "./CSlider.vue?vue&type=script&lang=ts&"
export * from "./CSlider.vue?vue&type=script&lang=ts&"
import style0 from "./CSlider.vue?vue&type=style&index=0&id=5df5a5b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df5a5b2",
  null
  
)

export default component.exports